/* global graphql */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import Link from 'gatsby-link'
import BlogNav from '../components/blog-nav'

const summaryBlog = (html) => {
  /** TODO:
   * Use the user providedsummary field if available.
   *
   * https://github.com/attn/attn-cms/pull/39#issuecomment-400160791
   */

  const convertHtml = html.replace(/<[^>]+>/g, '')
  const wordsHtml = convertHtml.split(' ')
  const summary = wordsHtml.reduce((brief, word, count) => {
    return (count < 50) ? brief + ' ' + word : brief
  })

  return summary + '...'
}

const BlogPage = ({ data, pathContext }) => {
  let blogList = []
  let categoryFilter = pathContext.categorySlug || 'All'
  const drupalCategory = (data.allDrupalCategory !== null) ? data.allDrupalCategory.edges : null

  if (data.allDrupalBlog) {
    blogList = data.allDrupalBlog.edges.map((blog, ind) => {
      const { title, date, category, author, body } = blog.node
      const bodyText = summaryBlog(body.value)
      const slug = blog.node.url.path.replace(/^\/blogs\//, '/blog/')

      return (
        <div className='blog--post' key={ind}>
          <div className='blog--category'>
            {category.entity.title}
          </div>
          <Link to={slug}><h2>{title}</h2></Link>
          <div className='blog--author-date'>
            By {author[0].entity.title} &#8226; {date.value}
          </div>
          <div className='blog__summary' dangerouslySetInnerHTML={{ __html: bodyText }} />
          <Link className='link--primary' to={slug}>Read More</Link>
        </div>
      )
    })
  } else {
    blogList[0] = <div key={1} className='blog--category-blank'>Sorry, there are no blog posts in this category.</div>
  }

  return (
    <div className='page--blog-index'>
      <Helmet title='Updates - ATTN:' />
      <Header hideOnScroll={false} fixed />
      <div className='wrapper--page wrapper--max-width wrapper--fixed-nav'>
        <div className='graphics--blog-circle' />
        <div className='graphics--blog-dot' />
        <div className='hero'>
          <h1>UPDATES</h1>
        </div>
        <div className='blog--page'>
          <BlogNav
            categoryFilter={categoryFilter}
            categorySlug={pathContext.categorySlug}
            drupalCategory={drupalCategory} />
          <div className='blog--post-list'>
            {blogList}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

BlogPage.propTypes = {
  data: PropTypes.object,
  pathContext: PropTypes.object
}

export const query = graphql`
  query BlogIndexQuery ($categorySlug: String) {
    allDrupalCategory (sort: {
      fields : [title],
      order: ASC
    } , limit: 100) {
        edges {
          node {
            id,
          title
          }
        }
    }

    allDrupalBlog (sort: {
        fields: [date___value],
        order: DESC
      },
      filter: {
        category: {
          entity: {
            title: {
              eq: $categorySlug
            }
          }
        }
      }) {
      edges {
        node {
          id
          title
          author {
            entity {
              title
              first
              last
              name
            }
          }
          category {
            entity {
              type
              title
            }
          }
          type
          published
          date {
            value(formatString: "MMMM D, YYYY")
          }
          url {
            routed
            path
          }
          body {
            value
            summary
          }
        }
      }
    }
  }
`

export default BlogPage



// WEBPACK FOOTER //
// ./src/layouts/blog-index.js